import { createRoute, redirect } from '@tanstack/react-router';

import { queryClient } from '@/lib/query-client';
import { axiosManager } from '@/api/api-client';
import { useStore } from '@/stores';
import type { Profile } from '@/stores/profile';
import type { MerchantRoleAccessResponse } from '@/stores/role-access';

import { rootRoute } from '../__root';

export const protectedRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: 'protected',
  beforeLoad: ({ context, location }) => {
    if (!context.authStore.accessToken)
      throw redirect({
        to: '/auth/login',
        search: { redirect: location.href },
      });
  },
  loader: async () => {
    const profile = await queryClient.fetchQuery({
      queryKey: ['profile'],
      queryFn: async (): Promise<Profile> => {
        const res = await axiosManager.httpWithAuth.get<Profile>('dashboard/v1/profile');
        useStore.getState().setProfile(res.data);
        return res.data;
      },
      staleTime: 1000 * 60 * 5,
    });

    const roleAccess = await queryClient.ensureQueryData({
      queryKey: ['role-access'],
      queryFn: async (): Promise<MerchantRoleAccessResponse> => {
        const res = await axiosManager.httpWithAuth.get<MerchantRoleAccessResponse>(
          'dashboard/v1/role/access',
        );
        useStore.getState().setMerchantAccess(res.data.data);
        return res.data;
      },
    });

    return { profile, roleAccess };
  },
});
